import { Link as RouterLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import {
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledMedia,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './SupportedChains.tokens';

const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.5);
`;

export const StyledSupportedChains = styled.div`
    display: grid;
    justify-content: center;
    justify-items: center;
    text-align: center;
`;

export const Title = styled.p`
    ${typographyBase};
    font-size: ${tokens.titleSize}px;
`;

export const List = styled.ul`
    ${styledReset.list};
    display: grid;
    grid-auto-flow: column;
    align-content: center;
    justify-content: center;
    text-align: center;
    margin-top: ${tokens.list.marginTop}px;
    gap: ${tokens.list.gap}px;
`;

export const Item = styled.li``;

export const Link = styled(RouterLink)`
    ${styledReset.link};
    ${typographyBase};
    display: grid;
    grid-auto-flow: column;
    align-content: center;
    gap: ${tokens.link.gap}px;
    font-size: ${tokens.link.fontSize}px;
    font-weight: 700;
    transition: color ${duration.normal}ms ${easing.cubic};

    &:focus,
    &:hover {
        color: rgb(255, 255, 255, 1);
    }

    &:active {
        color: rgb(255, 255, 255, 0.8);
    }
`;

export const LinkIcon = styled.span`
    ${styledMedia.iconWrapper};
    width: ${tokens.link.iconSize}px;
    height: ${tokens.link.iconSize}px;
`;

export const LinkText = styled.span``;

export const SuggestLink = styled(RouterLink)`
    ${styledReset.link};
    ${typographyBase};
    display: block;
    margin-top: ${tokens.suggestLink.marginTop}px;
    padding: ${tokens.suggestLink.padding}px;
    font-size: ${tokens.suggestLink.fontSize}px;
    border-radius: ${tokens.suggestLink.radius}px;
    color: rgba(255, 255, 255, 0.5);
    background-color: transparent;
    transition-property: color, background-color;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &:focus,
    &:hover {
        color: rgb(255, 255, 255, 0.8);
        background-color: rgb(255, 255, 255, 0.1);
    }

    &:active {
        color: rgb(255, 255, 255, 0.6);
        background-color: rgb(255, 255, 255, 0.06);
    }
`;
